import { render, staticRenderFns } from "./DxToolsMonthlyTable.vue?vue&type=template&id=fbeb7856&"
import script from "./DxToolsMonthlyTable.vue?vue&type=script&lang=js&"
export * from "./DxToolsMonthlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports